import React from "react";
import { useCurrentMenu } from "../../store/menu-app-context";
import { Menu } from "../MenuApps/Menu";
import { UnifiedMenuLayout } from "../UnifiedMenu/UnifiedMenuLayout";

export const SidebarMenu = () => {
    const { currentMenu } = useCurrentMenu();

    if (currentMenu === "NEW") return <UnifiedMenuLayout />;
    return <Menu />;
};
